import _ from 'lodash';

export default findLastUpdatedAppt;

/**
 * @name find
 * @description Function to find the last updated appointment based on the
 * last_status created date.
 * @param {array} collection The collection to group.
 * @return {array} latest Returns the grouped collection.
 */
function findLastUpdatedAppt(collection) {
  let latest = _.orderBy(collection, function(appointment) {
    return appointment.last_status.created;
  }, 'desc');
  return latest[0];
}



// WEBPACK FOOTER //
// ./utils/find-last-updated-appt.js